window.addEventListener('load', function() {
    let scriptElement = document.querySelector('script[data-lang]');
    // Zugriff auf das data-lang Attribut
    let dataLang = scriptElement.getAttribute('data-lang');


    /***
     *
     Frequently bought together
     *
     ***/
    let frequentlyBoughtTogetherContainer = document.querySelector('.cbb-frequently-bought-container');

    if (frequentlyBoughtTogetherContainer) {
        // Übersetzungen für verschiedene Elemente und Sprachen
        const fbtTranslations = {
            'headline': {
                'en': 'Frequently bought together',
                'de': 'Häufig zusammen gekauft',
            },
            'buttonText': {
                'en': 'Add selected to cart',
                'de': 'Ausgewählte in den Warenkorb legen',
            },
            'priceText': {
                'en': 'Price: ',
                'de': 'Gesamtpreis: ',
            },
            'thisArticleText': {
                'en': '',
                'de': 'Dieser Artikel: ',
            },
        };
        // Headline
        let fbtHeadline = frequentlyBoughtTogetherContainer.querySelector('.cbb-frequently-bought-title');
        if (fbtHeadline) {
            // Setze den Titel basierend auf der Sprache
            if (fbtTranslations['headline'][dataLang]) {
                fbtHeadline.innerHTML = fbtTranslations['headline'][dataLang];
            } else {
                // Verwende eine Standardübersetzung für die Überschrift
                fbtHeadline.innerHTML = fbtTranslations['headline']['en'];
            }
        }
        // Button
        let fbtButton = frequentlyBoughtTogetherContainer.querySelector('.cbb-frequently-bought-add-button span');
        if (fbtButton) {
            // Setze die Beschriftung des Buttons basierend auf der Sprache
            if (fbtTranslations['buttonText'][dataLang]) {
                fbtButton.innerHTML = fbtTranslations['buttonText'][dataLang];
            } else {
                // Verwende eine Standardübersetzung für den Button
                fbtButton.innerHTML = fbtTranslations['buttonText']['en'];
            }
        }
        // Preis
        let fbtPrice = frequentlyBoughtTogetherContainer.querySelector('.cbb-frequently-bought-total-price-text');
        if (fbtPrice) {
            if (fbtTranslations['priceText'][dataLang]) {
                fbtPrice.innerHTML = fbtTranslations['priceText'][dataLang];
            } else {
                fbtPrice.innerHTML = fbtTranslations['priceText']['en'];
            }
        }
        // Dieser Artikel
        let fbtThisArticle = frequentlyBoughtTogetherContainer.querySelector('.cbb-frequently-bought-this-item-label');
        if (fbtThisArticle) {
            if (fbtTranslations['priceText'][dataLang]) {
                fbtThisArticle.innerHTML = fbtTranslations['thisArticleText'][dataLang];
            } else {
                fbtThisArticle.innerHTML = fbtTranslations['thisArticleText']['en'];
            }
        }
    }
    /***
     *
     Subscription Plus
     *
     ***/
    /*
    let subscriptionPlusContainer = document.querySelector('#subscriptions__plus');
    if (subscriptionPlusContainer) {
        const subPlusTranslations = {
            'oneTimePurchaseText': {
                'en': 'One time purchase',
                'de': 'Einmaliger Kauf',
            },
            'subscriptionText': {
                'en': 'Subscribe and save money',
                'de': 'Abonnieren und sparen',
            },
            'subscriptionTooltipText': {
                'en': 'You can edit, skip, cancel and reschedule the subscription at any time.',
                'de': 'Du kannst das Abonnement jederzeit bearbeiten, überspringen, kündigen und neu terminieren.',
            },
            'deliveryText': {
                'en': 'Delivery',
                'de': 'Lieferung',
            },
            'deliveryFrequencyMonthly': {
                'en': ' monthly',
                'de': ' monatlich',
            },
            'deliveryFrequency2Months': {
                'en': 'every 2 months',
                'de': ' alle 2 Monate',
            },
            'agreementText': {
                'en': 'With our subscription you will receive this item at the selected regularity with a discount on every recurring order. The subscription can be canceled or changed at any time.',
                'de': 'Mit unserem Abo erhältst du diesen Artikel in der gewählten Regelmäßigkeit mit einem Rabatt auf jede wiederkehrende Bestellung. Das Abonnement kann jederzeit gekündigt oder geändert werden.',
            },
        };
        // Option: Einmaliger Kauf
        let subscriptionOptionOneTime = document.querySelector('label[for^="subscription-plus-one-time-"] .subscription-option__title');
        if (subscriptionOptionOneTime) {
            let optionCheckSpan = subscriptionOptionOneTime.querySelector('.option__check');
            let optionUnitPriceSpan = subscriptionOptionOneTime.querySelector('.unit-price');
            // Abrufen des gesamten HTML-Inhalts der Span-Elemente
            let optionCheckHTML = optionCheckSpan.outerHTML;
            let optionUnitPriceHTML = optionUnitPriceSpan.outerHTML;
            subscriptionOptionOneTime.innerHTML = optionCheckHTML + subPlusTranslations['oneTimePurchaseText'][dataLang] + optionUnitPriceHTML;
        }
        // Option: Abonnement mit Tooltip
        let subscriptionOptionSubscribe = document.querySelector('label[for^="subscribe-"] .subscription-option__title');
        if (subscriptionOptionSubscribe) {
            let optionSubCheckSpan = subscriptionOptionSubscribe.querySelector('.option__check');
            let optionSubUnitPriceSpan = subscriptionOptionSubscribe.querySelector('.unit-price');
            let optionSubTooltipText = subscriptionOptionSubscribe.querySelector('.subscription-tooltip-caption').innerHTML = subPlusTranslations['subscriptionTooltipText'][dataLang];
            let optionSubTooltip = subscriptionOptionSubscribe.querySelector('.subscription-tooltip').outerHTML;
            let optionSubCheckHTML = optionSubCheckSpan.outerHTML;
            let optionSubUnitPriceHTML = optionSubUnitPriceSpan.outerHTML;
            subscriptionOptionSubscribe.innerHTML = optionSubCheckHTML + '<span style="display:flex;">' + subPlusTranslations['subscriptionText'][dataLang] + optionSubTooltip + '</span>' + optionSubUnitPriceHTML;
        }
        //Lieferoptionen bei Subscription
        let subscriptionDelivery = document.querySelector('.subscription-option-frequency');
        if (subscriptionDelivery) {
            subscriptionDelivery.querySelector('p').innerHTML = subPlusTranslations['deliveryText'][dataLang];
        }

        let agreementText = subscriptionPlusContainer.querySelector('.subscription-plus-agreement span');
        agreementText.innerHTML = subPlusTranslations['agreementText'][dataLang];
    } */

}, false);